import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
import moment from 'moment';
/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as detailFatigueActions from '../../actions/detail_fatigue/index';
import * as driverFatigueActions from '../../actions/driver_fatigue/index';

/* Components */
import Header from '../../components/detail_fatigue/header';
import TitleMain from '../../components/common/titleMain';
import Label from '../../components/common/label';
import DriversAtRiskEvolutionGraph from '../../components/detail_fatigue/driversAtRiskEvolutionGraph';
import DriversRiskDistributionGraph from '../../components/detail_fatigue/driversRiskDristributionGraph';
import RankingTable from '../../components/common/tables/rankingTable';
import CircularIndicator from '../../components/common/indicators/circularIndicator';
import FatigueIndicators from '../../components/common/fatigue/fatigueIndicators';
import FatigueMoreDetailsModal from '../../components/common/fatigue/fatigueMoreDetailsModal';
import Avatar from '../../components/common/avatar';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import AvatarImg from '../../../../public/images/empresa.png';
import Expired from '../expired/index';

class DetailFatigue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFatigueIndicators: 0,
      showMoreDetailsModal: false
    };
  }

  componentWillUnmount() {
    this.props.actions.resetDetailFatigue();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('fatigue');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('fatigue')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const hasRisk = this.props.filters.hasRisk;
          await this.props.actions.fetchDetailFatigueApi({
            dateStart,
            dateEnd,
            tags,
            hasRisk
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleAtRiskFilterSubmit = e => {
    this.state.activeFatigueIndicators = e.target.selectedIndex;
    this.handleSubmit(e);
  };

  handleMoreDetailsClick = e => {
    e.preventDefault();
    this.setState({
      showMoreDetailsModal: true
    });
  };

  handleOnHideMoreDetailsModal = () => {
    this.setState({
      showMoreDetailsModal: false
    });
  };

  handleSubmit = async obj => {
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = (obj.multipleTagsInputIsMultiple) ? ObjGeneral.getTags(obj) : this.props.filters.tags;
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);
    /*RISK*/
    const hasRisk = this.props.datos.mainIndicators[this.state.activeFatigueIndicators] ? this.props.datos.mainIndicators[this.state.activeFatigueIndicators].name : '';

    this.props.actions.setFilterDetailFatigue({
      tags: tags,
      date: date,
      hasRisk: hasRisk
    });
    await this.props.actions.fetchDetailFatigueApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      hasRisk: hasRisk
    });
  };

  link = event => {
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    const tags = this.props.filters.tags;

    const driver = {
      id: event.currentTarget.dataset.driverid,
      alias: event.currentTarget.dataset.driveralias
    };
    document.getElementById('menu-1-sub-2').classList.remove('active');
    document.getElementById('menu-1-sub-3').classList.add('active');
    this.props.driverActions.setFilterDriverFatigue({
      tags: tags,
      date: date,
      driver: driver
    });
    this.props.history.push('/dashboard/driver_fatigue');
  };

  fecha = (filter, fecha, formatDate) => {
    if (filter) {
      return moment(filter).format(formatDate);
    } else if (fecha.response) {
      return moment(fecha.response.maxDate.substring(0, 10)).format(formatDate);
    }
    return '';
  };

  render() {
    const title = this.props.language.detail_fatigue ? this.props.language.detail_fatigue.title : '';
    const toolTip = this.props.language.detail_fatigue ? this.props.language.detail_fatigue.graphToolTip : '';
    const language = this.props.language ? this.props.language.filter : '';

    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.detailFatigue,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;

      return (
        <section className="main full-height detail-fatigue">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            date={this.props.dateMax[0]}
            handleSubmit={this.handleSubmit}
            language={language}
          />
          {this.props.loading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 || this.props.statusTags === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 && this.props.statusTags === 200 ? (
            <div className="main-container">
              <div className="left-col">
                <div className="top-left-section">
                  <div className="vertical-container">
                    <section className="operation-info">
                      <Avatar width={150} src={`${AvatarImg}`} />
                      <section className="drivers-at-risk-wrapper">
                        {this.props.datos.lastDriverRiskPercentage != null && (
                          <CircularIndicator
                            size={130}
                            max={100}
                            value={this.props.datos.lastDriverRiskPercentage}
                            forceValue={100}
                            fill={true}
                            id={'circle1'}
                            valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '%' }}
                            graphColorRange={graphColorRange.fatigueRiskPercentage}
                          />
                        )}
                        <Label label={this.props.language.detail_fatigue.labels.driversAtRiskKpi} />
                        <Label
                          label={this.fecha(
                            this.props.filters.date.fechaEndFinal,
                            this.props.dateMax[0],
                            this.props.language.account.date.format
                          )}
                        />
                        <section className="help-component circular-com">
                          <section className="box-help">
                            <i className="fas fa-question-circle" />
                            <section className="box">
                              {this.props.language.summary.fatigue.driversAtRiskText}
                            </section>
                          </section>
                        </section>
                      </section>
                    </section>
                  </div>
                </div>
                <section className="operation-ranking">
                  <TitleMain title={title.ranking} />
                  <div className="ranking-title-old">
                    <div className="a">{this.props.language.summary.tableTitle.numberRanking}</div>
                    <div className="b">{this.props.language.summary.tableTitle.driverName}</div>
                    <div className="c">{this.props.language.summary.tableTitle.biocompatibilityIndex}</div>
                  </div>

                  {this.props.datos.driverRanking.length > 0 && (
                    <RankingTable
                      language={this.props.language}
                      link={this.link}
                      data={this.props.datos.driverRanking}
                      kpiColumn={'fatigueGrade'}
                      nameColumn={'driverAlias'}
                      graphColorRange={graphColorRange.fatigueBiocompatibilityIndex}
                      filter={setting.filter}
                    />
                  )}
                </section>
              </div>
              <div className="right-col">
                <section className="operation-evolution">
                  <TitleMain title={title.evolution} className={'second'} />
                  {this.props.datos.fatigueRiskPercentageEvolutions.length > 0 && (
                    <DriversAtRiskEvolutionGraph
                      data={this.props.datos.fatigueRiskPercentageEvolutions}
                      language={this.props.language}
                      graphColorRange={graphColorRange.fatigueRiskPercentage}
                      toolTip={toolTip ? toolTip : ''}
                    />
                  )}
                </section>
                <section className="operation-distribution">
                  <TitleMain
                    title={title.distribution}
                    className={'second'}
                    info={{
                      text: this.props.language.summary.fatigue.ratesHistogramText
                    }}
                  />
                  {this.props.datos.ibchistogram.length > 0 && (
                    <DriversRiskDistributionGraph
                      data={this.props.datos.ibchistogram}
                      language={toolTip ? toolTip : ''}
                      graphColorRange={graphColorRange.fatigueBiocompatibilityIndex}
                    />
                  )}
                </section>
                <section className="operation-indicators">
                  <TitleMain
                    title={title.indicators}
                    className={'second'}
                    info={{
                      text: this.props.language.summary.fatigue.mainIndicatorsText
                    }}
                  />
                  <div className="operation-indicators-filter">
                    <Label label={this.props.language.detail_fatigue.labels.filterByRisk} />
                    <div className="box-form islabel box170 inner-dashboard-input">
                      <select
                        defaultValue={
                          this.props.filters.hasRisk ? this.props.filters.hasRisk : false
                        }
                        id="group"
                        onChange={this.handleAtRiskFilterSubmit}
                      >
                        {this.props.datos.mainIndicators.map((item, i) => (
                          <option value={item.name} key={`group-${i}`}>
                            {this.props.language.detail_fatigue.selects[item.name]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {this.props.datos.mainIndicators.length > 0 && (
                    <FatigueIndicators
                      class="min"
                      language={this.props.language.fatigue_indicators.labels}
                      data={this.props.datos.mainIndicators[this.state.activeFatigueIndicators]}
                      graphColorRange={graphColorRange.fatigueIndicators}
                      driverView={false}
                    />
                  )}
                  <div className="indicators-detail-button" onClick={this.handleMoreDetailsClick}>
                    {this.props.language.detail_fatigue.buttons.moreDetails}
                  </div>
                </section>
              </div>
              {this.props.datos.mainIndicatorsDetail && (
                <FatigueMoreDetailsModal
                  data={this.props.datos.mainIndicatorsDetail}
                  onHide={this.handleOnHideMoreDetailsModal}
                  show={this.state.showMoreDetailsModal}
                />
              )}
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 || this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}

const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.detailFatigue.datos,
  loading: state.reducer.detailFatigue.loading,
  status: state.reducer.detailFatigue.status,
  filters: state.reducer.detailFatigue.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detailFatigueActions, dispatch),
  driverActions: bindActionCreators(driverFatigueActions, dispatch)
});

DetailFatigue.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailFatigue);



// WEBPACK FOOTER //
// ./source/client/containers/detail_fatigue/index.jsx